import { Typography } from "PFComponents/typography";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PropertyFieldProps } from "../property";
import css from "./properties_fields.module.scss";

export const NotSupportedField = ({ fieldName, label, type }: PropertyFieldProps) => {
  const { watch } = useFormContext();
  const { t } = useTranslation("saasAdmin");
  const value = watch(fieldName);

  return (
    <div className={css.notSupportedField}>
      <Typography variant="bodyBold">{t("filtersConfig.notSupportedField") as string}</Typography>
      <Typography variant="bodyRegular" noMargin>
        {label}
      </Typography>
      <Typography variant="bodyRegular" noMargin>
        {type}
      </Typography>
      <Typography variant="bodyRegular" noMargin>
        {JSON.stringify(value)}
      </Typography>
    </div>
  );
};
